import React from "react";
import BarGraph from "./BarGraph";
import ReactWordcloud from "react-wordcloud";
import "tippy.js/dist/tippy.css";
import "tippy.js/animations/scale.css";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import * as Icon from "react-bootstrap-icons";
import { DateRange, DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import { fetchDashboardData } from "../../redux/actions/dashboardAction";
import { useDispatch } from "react-redux";
import { Mixpanel } from "../../Mixpanel";
import { useNavigate } from "react-router-dom";


const Funnel = (props) => {
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const currentDate = moment();
  const [mobileView, setMobileView] = useState(false);
  const [barData, setBarData] = useState([]);
  const [rangeString, setRangeString] = useState("today");
  const [showCalendar, setShowCalendar] = useState(false);
  const [dateRange, setDateRange] = React.useState({
    startDate: currentDate.format("YYYY-MM-DD"),
    endDate: currentDate.format("YYYY-MM-DD"),
  });
  const [selectedDates, setSelectedDates] = React.useState([
    {
      startDate: new Date(),
      endDate: null,
      key: "selection",
    },
  ]);
  const dashboardData = useSelector(
    (state) => state.dashboard.fetchDashboardData
  );

  const handleCalendar = (ranges) => {
    setShowCalendar(false);
    const { startDate, endDate } = selectedDates[0];
    const formattedStartDate = moment(startDate).format("YYYY-MM-DD");
    const formattedEndDate = moment(endDate).format("YYYY-MM-DD");

    const formattedRange = {
      startDate: formattedStartDate,
      endDate: formattedEndDate,
    };

    setDateRange(formattedRange);
  };

  const handleTagClick = (buttonType) => {
    setShowCalendar(false);
    const currentDate = moment();
    setRangeString(buttonType);
    setSelectedDates([
      {
        startDate: new Date(),
        endDate: null,
        key: "selection",
      },
    ]);

    switch (buttonType) {
      case "all":
        setDateRange({
          startDate: "",
          endDate: "",
        });
        break;
      case "today":
        setDateRange({
          startDate: currentDate.format("YYYY-MM-DD"),
          endDate: currentDate.format("YYYY-MM-DD"),
        });
        break;
      case "yesterday":
        setDateRange({
          startDate: currentDate
            .clone()
            .subtract(1, "day")
            .format("YYYY-MM-DD"),
          endDate: currentDate.clone().subtract(1, "day").format("YYYY-MM-DD"),
        });
        break;
      case "lastWeek":
        setDateRange({
          startDate: currentDate
            .clone()
            .subtract(1, "week")
            .startOf("week")
            .format("YYYY-MM-DD"),
          endDate: currentDate
            .clone()
            .subtract(1, "week")
            .endOf("week")
            .format("YYYY-MM-DD"),
        });
        break;
      case "lastMonth":
        setDateRange({
          startDate: currentDate
            .clone()
            .subtract(1, "month")
            .startOf("month")
            .format("YYYY-MM-DD"),
          endDate: currentDate
            .clone()
            .subtract(1, "month")
            .endOf("month")
            .format("YYYY-MM-DD"),
        });
        break;
      default:
        // Default case
        break;
    }
  };

  useEffect(() => {
    Mixpanel.track("Acessed Analytics.")
    if (window.innerWidth <= 768) {
      setMobileView(true);
    } else {
      setMobileView(false);
    }
  }, []);

  const options = {
    // colors: ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd", "#8c564b"],
    colors: ["#666666"],
    enableTooltip: true,
    deterministic: true,
    fontFamily: "inter",
    fontSizes: [5, 50],
    fontStyle: "normal",
    fontWeight: "normal",
    padding: 5,
    rotations: 2,
    rotationAngles: [0, 90],
    scale: "sqrt",
    spiral: "archimedean",
    transitionDuration: 1000,
  };

  useEffect(() => {
    const barGraphData = [
      dashboardData?.details?.bar_chart_data?.visited,
      dashboardData?.details?.bar_chart_data?.chat_started,
      dashboardData?.details?.bar_chart_data?.info_given,
      // dashboardData?.details?.bar_chart_data?.meeting_setup,
    ];
    setBarData(barGraphData);
  }, [dashboardData]);

  useEffect(() => {
    dispatch(
      fetchDashboardData(
        props.authToken,
        dateRange?.startDate,
        dateRange?.endDate
      )
    );
  }, [dateRange]);

  const clickData ={
    endDate:dateRange?.endDate,
    startDate:dateRange?.startDate,
    rangeString:rangeString
  }


  return (
    <>
      <div className="px-16 max-sm:px-6 flex justify-between shadow-md mb-4 bg-white">
        <div className="flex flex-col my-2">
          <div className="text-lg leading-7 font-normal text-gray-700">
            Hello,
          </div>
          <div className="text-2xl leading-8 font-medium capitalize text-gray-900">
            {dashboardData?.details?.profile_name}
          </div>
        </div>
        {/* <div className='flex mt-3'>
          <div className='flex flex-col px-4 cursor-pointer border-solid border-b-2 border-violet-500 '  onClick={()=>{navigate("/Analytics")}}>
            <div className='text-lg leading-7 font-semibold text-violet-500'>Leads</div>
            <div className='text-sm leading-5 font-normal text-gray-400'>47 new leads</div>
          </div>
          <div className='flex flex-col px-4 cursor-pointer' onClick={()=>{navigate("/Analytics/Accounts")}}>
            <div className='text-lg leading-7 font-semibold text-gray-700'>Accounts</div>
            <div className='text-sm leading-5 font-normal text-gray-400'>20% Active accounts</div>
          </div>
        </div> */}
      </div>
      <div className="px-4 sm:px-16 flex flex-col">
        <div className="top flex max-lg:justify-start justify-center pb-4 pt-1 ">
          <div className="flex max-sm:block my-auto items-center relative">
            {/* <div className="text-lg leading-7 font-[500] mr-2 max-sm:my-4">
            Conversation History
          </div> */}
            <div className="tagsContainer flex max-sm:mb-2">
              {/* <div
              className={`font-[Inter] font-[500] leading-[15px] rounded-[16px] py-[5px] px-[10px] text-xs max-sm:text-[10px] cursor-pointer mr-1  ${
                rangeString === "all"
                  ? "border border-[var(--brand-primary)] text-[var(--brand-primary)]"
                  : "hover:border hover:border-[var(--brand-primary)] hover:text-[var(--brand-primary)] text-[#6B7280] border border-[#6B7280]"
              }`}
              onClick={() => {
                handleTagClick("all");
              }}
            >
              All
            </div> */}
              <div
                className={`font-[Inter] font-[500] leading-[15px] rounded-[16px] py-[5px] px-[10px] text-xs max-sm:text-[10px] cursor-pointer mr-1  ${
                  rangeString === "today"
                    ? "border border-[var(--brand-primary)] text-[var(--brand-primary)]"
                    : "hover:border hover:border-[var(--brand-primary)] hover:text-[var(--brand-primary)] text-[#6B7280] border border-[#6B7280]"
                }`}
                onClick={() => {
                  handleTagClick("today");
                }}
              >
                Today
              </div>
              <div
                className={`font-[Inter] font-[500] leading-[15px] rounded-[16px] py-[5px] px-[10px] text-xs max-sm:text-[10px] cursor-pointer mr-1  ${
                  rangeString === "yesterday"
                    ? "border border-[var(--brand-primary)] text-[var(--brand-primary)]"
                    : "hover:border hover:border-[var(--brand-primary)] hover:text-[var(--brand-primary)] text-[#6B7280] border border-[#6B7280]"
                }`}
                onClick={() => {
                  handleTagClick("yesterday");
                }}
              >
                Yesterday
              </div>
              <div
                className={`font-[Inter] font-[500] leading-[15px] rounded-[16px] py-[5px] px-[10px] text-xs max-sm:text-[10px] cursor-pointer mr-1  ${
                  rangeString === "lastWeek"
                    ? "border border-[var(--brand-primary)] text-[var(--brand-primary)]"
                    : "hover:border hover:border-[var(--brand-primary)] hover:text-[var(--brand-primary)] text-[#6B7280] border border-[#6B7280]"
                }`}
                onClick={() => {
                  handleTagClick("lastWeek");
                }}
              >
                Last Week
              </div>
              <div
                className={`font-[Inter] font-[500] leading-[15px] rounded-[16px] py-[5px] px-[10px] text-xs max-sm:text-[10px] cursor-pointer mr-1  ${
                  rangeString === "lastMonth"
                    ? "border border-[var(--brand-primary)] text-[var(--brand-primary)]"
                    : "hover:border hover:border-[var(--brand-primary)] hover:text-[var(--brand-primary)] text-[#6B7280] border border-[#6B7280]"
                }`}
                onClick={() => {
                  handleTagClick("lastMonth");
                }}
              >
                Last Month
              </div>
              
            </div>
            <div className="flex flex-wrap justify-between">
              {dateRange.endDate !== null && rangeString === "calendar" && (
                <div
                  className={`font-[Inter] font-[500] leading-[15px] rounded-[16px] py-[5px] px-[10px] text-xs cursor-pointer me-1 ${
                    rangeString === "calendar"
                      ? "border border-[var(--brand-primary)] text-[var(--brand-primary)]"
                      : ""
                  }`}
                  onClick={() => {
                    setShowCalendar(!showCalendar);
                    setRangeString("calendar");
                  }}
                >
                  {dateRange?.startDate}/{dateRange?.endDate}
                </div>
              )}
              {(selectedDates[0].endDate == null ||
                dateRange.endDate == null) && (
                <div
                  className={`font-[Inter] font-[500] leading-[15px] rounded-[16px] py-[5px] px-[10px] text-xs max-sm:text-[10px] flex mr-1 my-auto cursor-pointer ${
                    rangeString === "calendar"
                      ? "border border-[var(--brand-primary)] text-[var(--brand-primary)]"
                      : "hover:border hover:border-[var(--brand-primary)] hover:text-[var(--brand-primary)] text-[#6B7280] border border-[#6B7280]"
                  }`}
                  onClick={() => {
                    setShowCalendar(!showCalendar);
                    setRangeString("calendar");
                    setDateRange({
                      startDate: null,
                      endDate: null,
                    });
                  }}
                >
                  Choose Time Duration{" "}
                  <Icon.CalendarDate className="ml-1 my-auto" />
                </div>
              )}
              </div>
              {showCalendar && (
                <div className="font-[Inter] font-[500] leading-[15px] rounded-[16px] py-[5px] px-[10px] bg-[white] left-3/4 top-[119%] z-10 border border-gray-400 max-sm:left-0 max-sm:top-full text-xs mr-1 my-auto absolute">
                  <DateRange
                    editableDateInputs={true}
                    onChange={(ranges) => {
                      setSelectedDates([ranges.selection]);
                    }}
                    moveRangeOnFirstSelection={false}
                    ranges={selectedDates}
                    showMonthAndYearPickers={true}
                    showDateDisplay={false}
                    // initialFocusedRange={[17-18]}
                  />
                  <div className="flex w-full">
                    <div className="ms-auto flex">
                      <div
                        className="py-[8px] px-[16px] bg-[#4D9AFF] rounded-[20px] text-center text-white outline-none border-none cursor-pointer mr-2"
                        onClick={() => setShowCalendar(false)}
                      >
                        Cancel
                      </div>
                      <div
                        className="py-[8px] px-[16px] bg-[#4D9AFF] rounded-[20px] text-center text-white outline-none border-none cursor-pointer"
                        onClick={() => {
                          handleCalendar();
                        }}
                      >
                        OK
                      </div>
                    </div>
                  </div>
                </div>
              )}
          </div>
        </div>
        {/* Top Section */}
        <div className="grid grid-cols-9 gap-11">
          <div className="max-sm:col-span-9 max-lg:col-span-5 col-span-2 grid grid-rows-1">
            <div className="rounded-[40px] p-8 bg-[#701A75] flex flex-col">
              <div className="my-auto">
                <div className="text-white text-3xl leading-6 font-bold mb-3">
                  {dashboardData?.details?.engaged_users_percent
                    ? dashboardData?.details?.engaged_users_percent
                    : 0}
                  %
                </div>
                <div className="text-gray-300 text-sm leading-5 font-medium">
                  People who visited your website engaged with Zoi. That’s
                  Amazing!
                </div>
              </div>
            </div>
          </div>
          <div className="max-lg:col-span-9 col-span-7 grid grid-rows-1">
            <div className="rounded-lg p-6 shadow-md bg-white">
              <div className="grid grid-cols-9">
                {/* left box */}
                <div className="col-span-9 sm:col-span-2 grid grid-rows-2">
                  <div className="grid grid-cols-1">
                    <div className="px-6">
                      <div className="flex justify-between border-b border-3 border-gray-200 pb-2">
                        <div className="text-sm leading-5 font-medium text-gray-500">
                          Chat to Lead Ratio
                        </div>
                        {/* <div className='text-sm leading-5 font-bold text-red-600'>-5.4%</div> */}
                      </div>
                      <div className="pt-3 text-2xl leading-8 font-semibold">
                        {dashboardData?.details?.funnel_data?.chat_to_lead
                          ? Math.floor(
                              dashboardData?.details?.funnel_data?.chat_to_lead
                            )
                          : 0}
                        %
                      </div>
                    </div>
                  </div>
                  <div className="grid grid-cols-1">
                    <div className="px-6">
                      <div className="flex justify-between border-b border-3 border-gray-200 pb-2">
                        <div className="text-sm leading-5 font-medium text-gray-500">
                          Average Conversation Duration
                        </div>
                        {/* <div className='text-sm leading-5 font-bold text-green-600'>+5.4%</div> */}
                      </div>
                      <div className="pt-3 text-2xl leading-8 font-semibold">
                        {dashboardData?.details?.funnel_data?.avg_convo_time
                          ? dashboardData?.details?.funnel_data?.avg_convo_time
                          : `0:0:00`}
                      </div>
                    </div>
                  </div>
                </div>
                {/* Right box */}
                <div className="col-span-9 sm:col-span-7 grid grid-rows-1">
                  <BarGraph mobileView={mobileView} barData={barData} clickData={clickData}/>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Bottom section */}
        <div className="grid grid-cols-8 gap-11 my-6">
          <div className="max-lg:col-span-8 col-span-4 grid grid-rows-1">
            <div className="rounded-lg p-1 shadow-md bg-white">
              <div className="pl-6 py-5 text-base leading-6 font-semibold text-gray-900 border-b border-gray-200">
                Word Cloud
              </div>
              {dashboardData?.details?.word_cloud?.length > 0 ? <div className="pt-2">
                <ReactWordcloud words={dashboardData?.details?.word_cloud} options={options} />
              </div>: <div className="flex justify-center items-center">
                  <div className="text-[rgba(33,33,33,0.3)] text-[17px] py-[20%] font-[bolder] text-center font-add">
                  <span className="flex justify-center items-center text-[40px]">
                    <Icon.Inbox />
                  </span>
                  No Data
                </div>
                  </div>}
            </div>
          </div>
          <div className="max-lg:col-span-8 col-span-4 grid grid-rows-1">
            <div className="rounded-lg p-1 shadow-md bg-white">
              <div className="pl-6 py-5 text-base leading-6 font-semibold text-gray-900 border-b border-gray-200">
                Top Conversations
              </div>
              <div className="divide-y overflow-y-auto max-h-[55vh] listing">
                {dashboardData && dashboardData?.details?.convo_summary_data?.length > 0 ?
                  dashboardData?.details?.convo_summary_data?.map((item) => {
                    return (
                      <div className="flex max-lg:block justify-between py-3 px-4">
                        <div className="text-gray-900 text-sm leading-5 font-medium mr-2">
                          {item?.summary}
                        </div>
                        <div className="text-gray-700 text-xs leading-4 font-bold">
                          {item?.prospect_name}
                        </div>
                      </div>
                    );
                  }):
                  <div className="flex justify-center items-center">
                  <div className="text-[rgba(33,33,33,0.3)] text-[17px] py-[20%] font-[bolder] text-center font-add">
                  <span className="flex justify-center items-center text-[40px]">
                    <Icon.Inbox />
                  </span>
                  No Data
                </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Funnel;
